var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMoreSummary = function SvgMoreSummary(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "24 / more"
  }, /*#__PURE__*/React.createElement("rect", {
    id: 1,
    x: 2.00006,
    y: 22.0001,
    width: 44,
    height: 4,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    id: 2,
    x: 26.0001,
    y: 1.99988,
    width: 44,
    height: 4,
    transform: "rotate(90 26.0001 1.99988)",
    fill: "currentColor"
  }))));
};
export default SvgMoreSummary;